import Vue from "vue";
import { Locales } from "@/enums/enums";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import en from "./en.json";
import th from "./th.json";

const messages = {
  [Locales.EN]: en,
  [Locales.TH]: th,
};

const defaultLocale = Locales.TH;

export const i18n = new VueI18n({
  messages,
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  silentTranslationWarn: true,
});
